module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features features-home stats-page"
  }, [_c('input', {
    attrs: {
      "id": "current_explorer",
      "type": "hidden"
    }
  }), _c('input', {
    attrs: {
      "id": "current_coin",
      "type": "hidden"
    }
  }), (_vm.showQR) ? _c('GenerateQR', {
    attrs: {
      "address": _vm.addressFromDB,
      "memo": _vm.memo
    },
    on: {
      "close": function($event) {
        _vm.showQR = false
      }
    }
  }) : _vm._e(), (_vm.showConnectionId) ? _c('ConnectionId', {
    attrs: {
      "connectionId": _vm.connectionId,
      "address": _vm.getFormattedAddressShort(_vm.addressFromDB),
      "memo": _vm.memo,
      "coin": _vm.coin
    },
    on: {
      "close": function($event) {
        _vm.showConnectionId = false
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [(_vm.showSearch) ? _c('div', {
    staticClass: "column col-result first-col-result is-full"
  }, [_c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "start-info"
  }, [_c('div', {
    staticClass: "title-mining"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("View ")]), _c('span', [_vm._v(" your ")]), _c('coin-switcher', {
    class: {
      'no-pointer-events': _vm.noPointerEvents
    },
    attrs: {
      "hintTop": true
    },
    on: {
      "selected": _vm.selectCoinFromSwitcher
    }
  }), _c('span', [_vm._v(" stats")])], 1)])]), (_vm.newCoins.length || _vm.recentCoins.length > 1) ? _c('div', {
    staticClass: "features address-info"
  }, [_c('span', {
    staticClass: "fs-14 recent-item-el"
  }, [_vm._v("Or search on")]), _c('div', {
    staticClass: "newest-list"
  }, [_vm._l((_vm.recentCoins), function(i) {
    return (i.symbol != _vm.coin) ? _c('div', {
      staticClass: "new-coin hint--bottom-right",
      class: {
        'is-loading': _vm.loadingCoin === i.symbol
      },
      attrs: {
        "aria-label": i.name + ' (' + i.symbol + ')'
      },
      on: {
        "click": function($event) {
          return _vm.selectNewCoin(i)
        }
      }
    }, [(i.top === 1) ? _c('div', {
      staticClass: "new-tag"
    }) : _vm._e(), (_vm.loadingCoin === i.symbol) ? _c('div', {
      staticClass: "new-coin-loading"
    }, [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e(), _c('div', {
      staticClass: "new-coin-logo"
    }, [_c('img', {
      attrs: {
        "src": i.logo
      }
    })])]) : _vm._e()
  }), (_vm.newCoins.length && _vm.recentCoins.length > 1) ? _c('div', {
    staticClass: "new-coin-separator"
  }) : _vm._e(), _vm._l((_vm.newCoins), function(i) {
    return (i.symbol != _vm.coin) ? _c('div', {
      staticClass: "new-coin hint--bottom-right",
      class: {
        'is-loading': _vm.loadingCoin === i.symbol
      },
      attrs: {
        "aria-label": i.name + ' (' + i.symbol + ')'
      },
      on: {
        "click": function($event) {
          return _vm.selectNewCoin(i)
        }
      }
    }, [(i.top === 1) ? _c('div', {
      staticClass: "new-tag"
    }) : _vm._e(), (_vm.loadingCoin === i.symbol) ? _c('div', {
      staticClass: "new-coin-loading"
    }, [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e(), _c('div', {
      staticClass: "new-coin-logo"
    }, [_c('img', {
      attrs: {
        "src": i.logo
      }
    })])]) : _vm._e()
  }), _c('div', {
    staticClass: "new-coin view-all recent-item-el",
    on: {
      "click": function($event) {
        return _vm.openCoinSwitcher()
      }
    }
  }, [_c('span', [_vm._v("View all")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 2)]) : _vm._e(), _c('div', {
    staticClass: "features address-info mt-20"
  }, [_vm._m(0), _c('div', {
    staticClass: "field field-address has-addons position-relative address-search-field"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded position-relative",
    class: {
      'is-loading': _vm.isFindingAddress
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input is-medium",
    attrs: {
      "id": "address_input",
      "type": "text",
      "placeholder": 'Your ' + _vm.coin + ' address',
      "disabled": _vm.isFindingAddress || _vm.disableInput || _vm.loadingCoin != '',
      "autocomplete": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.findAddressPre.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control button-address-container",
    attrs: {
      "id": "find_address"
    }
  }, [_c('a', {
    staticClass: "button is-success is-medium button-address",
    class: {
      'no-pointer-events': _vm.noPointerEvents
    },
    attrs: {
      "disabled": _vm.isFindingAddress || _vm.disableInput || _vm.loadingCoin != ''
    },
    on: {
      "click": _vm.findAddressPre
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), (_vm.isMemoCoin) ? _c('div', {
    staticClass: "label-info-memo mb-15 addon"
  }, [_c('span', [_vm._v("If you are using an exchange address that requires a payment tag or memo search ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v(" YourAddress")]), _c('b', {
    staticStyle: {
      "margin": "0px 1.5px"
    }
  }, [_vm._v(":")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("YourMemo")])]) : _vm._e(), (_vm.listOfLastAddresses.length > 0) ? [(_vm.listOfCoins.length > 1) ? [_vm._m(1), _c('coin-filter', {
    class: {
      'no-pointer-events': _vm.noPointerEvents
    },
    attrs: {
      "listOfCoins": _vm.listOfCoins
    },
    on: {
      "selected": _vm.toggleFilterCoin
    }
  })] : _vm._e(), _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, _vm._l((_vm.listOfLastAddresses), function(o, index) {
    return _c('div', {
      staticClass: "column is-half-tablet is-half-desktop is-one-third-widescreen is-one-third-fullhd is-one-mobile"
    }, [_c('div', {
      staticClass: "prev-address"
    }, [_c('div', {
      staticClass: "box",
      class: {
        'no-pointer-events': _vm.noPointerEvents
      },
      on: {
        "click": function($event) {
          return _vm.selectAddressFromFinder(o)
        }
      }
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": o.coinLogo,
        "alt": o.coin + ' logo'
      }
    })]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "content-address"
    }, [_c('strong', {
      staticClass: "long"
    }, [_vm._v(_vm._s(o.formattedAddress || o.address) + " ")]), _c('strong', {
      staticClass: "medium"
    }, [_vm._v(_vm._s(o.formattedAddressMedium || o.address) + " ")]), _c('strong', {
      staticClass: "short"
    }, [_vm._v(_vm._s(o.formattedAddressShort || o.address) + " ")])]), _c('div', {
      staticClass: "content-balance"
    }, [_c('div', {
      staticClass: "fs-12"
    }, [_vm._v("Balance ")]), _c('div', {
      staticClass: "count-up-balance"
    }, [(o.uuid && o.balance) ? [_c('span', {
      class: {
        'animate-long': o.animate
      }
    }, [_vm._v(_vm._s(o.balance))])] : [_c('span', [_vm._v("***")])]], 2)]), (_vm.reloadLastViewed) ? _c('div', {
      staticClass: "content-last"
    }, [(o.updated) ? _c('span', [_vm._v("Updated " + _vm._s(_vm._f("fromNow")(o.updated)))]) : _c('span', [_vm._v("Not yet mining")])]) : _vm._e()]), _c('div', {
      staticClass: "remove hint--top-left",
      attrs: {
        "aria-label": "Remove from the history"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeAddressFromLastAddress(o, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)] : _vm._e()], 2)]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSearch && !_vm.isMissingMemo),
      expression: "!showSearch && !isMissingMemo"
    }],
    staticClass: "column col-result"
  }, [_c('button', {
    staticClass: "button button-back-search",
    on: {
      "click": function($event) {
        return _vm.closeCurrentAddress()
      }
    }
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  }), _c('span', [_vm._v("Back")])]), (_vm.lastAddressesCoin.length) ? _vm._l((_vm.lastAddressesCoin), function(item) {
    return _c('button', {
      staticClass: "button button-back-search address-history",
      on: {
        "click": function($event) {
          return _vm.selectAddressFromPrevious(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.coinLogo,
        "alt": item.coin + ' logo'
      }
    }), _c('span', [_vm._v(_vm._s(_vm.isMobile ? item.formattedAddressShort : item.formattedAddressMedium))])])
  }) : _vm._e(), _c('div', {
    staticClass: "button button-back-search address-history button-coin-inline"
  }, [_c('coin-switcher', {
    class: {
      'no-pointer-events': _vm.noPointerEvents
    },
    attrs: {
      "compact": true
    },
    on: {
      "selected": _vm.selectCoinFromCompactSwitcher
    }
  })], 1), _c('button', {
    staticClass: "button button-back-search address-history quick-search",
    class: {
      'loading-quick': _vm.isFindingAddress || _vm.disableInput || _vm.loadingCoin != '',
      'hint--always': _vm.showAlwaysReload,
      'hint--right': !_vm.isMobile,
      'hint--bottom': _vm.isMobile
    },
    attrs: {
      "onclick": "document.getElementById('quick').focus()",
      "aria-label": 'Search ' + (('aeiou'.split('').indexOf((_vm.preCoin[0]).toLowerCase()) > -1) ? 'an' : 'a') + ' ' + _vm.preCoin + ' address!'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressQuickSearch),
      expression: "addressQuickSearch"
    }],
    staticClass: "input is-small",
    class: {
      'searching': _vm.addressQuickSearch
    },
    attrs: {
      "id": "quick",
      "placeholder": "Quick search",
      "disabled": _vm.isFindingAddress || _vm.disableInput || _vm.loadingCoin != '',
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.addressQuickSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.findAddressPreQuick.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressQuickSearch = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-search search-icon",
    class: {
      'searching': _vm.addressQuickSearch
    },
    on: {
      "click": _vm.findAddressPreQuick
    }
  })]), _c('div', {
    staticClass: "result-address"
  }, [_c('div', {
    staticClass: "info-miner w100 pos-r padding-container has-text-left"
  }, [_c('div', {
    staticClass: "big-info main"
  }, [_c('div', {
    staticClass: "is-flex aic balance-container"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v("Balance ")]), (!_vm.inactiveAccount) ? [_c('span', {
    staticClass: "animated-circle hint--bottom-right",
    attrs: {
      "aria-label": "Updating in real-time"
    }
  })] : [_c('span', {
    staticClass: "animated-circle inactive hint--bottom-right hint--large",
    class: {
      'hint--always': _vm.showAlwaysInactivity || _vm.showAlwaysReload
    },
    attrs: {
      "aria-label": "Your account is currently inactive. It will be cleared from our records after 6 months of no activity. For more information, please review our Terms & Conditions in the Support section."
    }
  })], _c('span', {
    staticClass: "top-option"
  }, [(_vm.miningFee == '0.75') ? _c('span', {
    staticClass: "top-option-text"
  }, [_vm._v("0.75% ")]) : _c('span', {
    staticClass: "top-option-text"
  }, [_vm._v("1% ")]), _c('span', {
    staticClass: "top-option-text"
  }, [_vm._v("mining fee ")]), (_vm.miningFee == '0.75') ? _c('span', {
    staticClass: "top-option-text top-fee-disclaimer hint--bottom-right has-text-left fw-400 hint--show-mobile",
    attrs: {
      "aria-label": "Fee lowered for using a valid referral code!"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]) : _c('span', {
    staticClass: "top-option-text top-fee-disclaimer hint--bottom has-text-left hint--medium fw-400 hint--show-mobile",
    attrs: {
      "aria-label": "Lower your fee by using a referral code in at least one worker!"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })])]), _c('span', {
    staticClass: "top-option"
  }, [_c('span', {
    staticClass: "top-option-text"
  }, [_vm._v(_vm._s(_vm.network) + " ")]), _c('span', {
    staticClass: "top-option-text"
  }, [_vm._v("chain ")]), (_vm.chains.length > 1) ? _c('span', {
    staticClass: "top-option-text top-fee-disclaimer hint--bottom-right has-text-left hint--large fw-400 hint--show-mobile",
    attrs: {
      "aria-label": "We support multiple payout chains for this coin / token. If you are switching between compatible chains, double check that you can receive your coins to the same exact address on the chain that you choose, otherwise you will lose your funds when processing a payout. You can also benefit from lower payment thresholds when using different chains."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]) : _vm._e()]), _c('div', {
    key: "balance-number",
    staticClass: "big-info-number balance",
    class: {
      'is-loading': _vm.isFindingAddress && _vm.balance === 0
    }
  }, [_c('div', {
    staticClass: "min-height-balance"
  }, [(_vm.forceReRender) ? _c('count-up', {
    staticClass: "count-up-balance",
    class: {
      'large-amount': _vm.balance && _vm.balance.indexOf('.') > 6
    },
    style: (_vm.calculatedBalanceFontSize ? 'font-size:' + _vm.calculatedBalanceFontSize + 'px' : ''),
    attrs: {
      "endVal": +_vm.balance,
      "options": _vm.countUpAmountOptions
    }
  }) : _vm._e(), _c('img', {
    attrs: {
      "src": _vm.coinLogo,
      "alt": _vm.coin + ' logo'
    }
  })], 1)])], 2)]), _c('div', {
    staticClass: "current-address-view"
  }, [_c('span', [_vm._v("Address  ")]), _c('span', {
    staticClass: "address_ hint--top",
    attrs: {
      "aria-label": 'Click to copy!'
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.addressFromDB, 'address')
      }
    }
  }, [_vm._v(_vm._s(_vm.trimmedAddress))]), (_vm.memo) ? _c('div', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
  }) : _vm._e(), (_vm.memo) ? _c('span', [_vm._v(" Memo  ")]) : _vm._e(), (_vm.memo) ? _c('span', {
    staticClass: "address_ hint--top",
    attrs: {
      "aria-label": 'Click to copy!'
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.memo, 'memo or payment tag')
      }
    }
  }, [_vm._v(_vm._s(_vm.trimmedMemo))]) : _vm._e(), (_vm.selectedChain.explorer_address) ? _c('a', {
    staticClass: "reload-control is-hidden-mobile hint--top",
    attrs: {
      "href": _vm.selectedChain.explorer_address_link,
      "target": "_blank",
      "aria-label": "View on public explorer"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })]) : _vm._e(), _c('span', {
    staticClass: "reload-control is-hidden-mobile hint--bottom-left",
    class: {
      'hint--always': _vm.showAlwaysReload
    },
    attrs: {
      "aria-label": "Use your Mining Key to simplify your mining setup"
    },
    on: {
      "click": _vm.openConnectionId
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _c('span', {
    staticClass: "reload-control is-hidden-mobile hint--top",
    attrs: {
      "aria-label": "Generate a QR code / View full address"
    },
    on: {
      "click": _vm.generateQR
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  })]), _c('span', {
    staticClass: "reload-control is-hidden-mobile hint--right",
    class: {
      'hint--always': _vm.showAlwaysReload
    },
    attrs: {
      "aria-label": "Reload Stats"
    },
    on: {
      "click": _vm.reloadStats
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isFindingAddress
    }
  })])]), _c('TransitionGroup', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isOpenPayingOutNow && !_vm.isOpenSwitchingNetwork) ? _c('div', {
    key: "buttons",
    staticClass: "pay-block"
  }, [(!(!_vm.isEnabled && _vm.isEnabledOnlyAutomatic)) ? _c('button', {
    staticClass: "button is-normal is-info",
    class: {
      'hint--top': _vm.hasPayoutNowDisabled
    },
    attrs: {
      "id": "pre_do_pay",
      "disabled": _vm.hasPayoutNowDisabled,
      "aria-label": _vm.messageCanNotPayoutNow
    },
    on: {
      "click": _vm.openPayoutNow
    }
  }, [_vm._v("Payout now  ")]) : _vm._e(), (_vm.chains.length > 1) ? _c('button', {
    staticClass: "button is-normal is-warning",
    attrs: {
      "id": "pre_switch_network"
    },
    on: {
      "click": _vm.openSwitchNetwork
    }
  }, [_vm._v("Switch network")]) : _vm._e(), (_vm.selectedChain.explorer_address) ? _c('a', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd",
    attrs: {
      "href": _vm.selectedChain.explorer_address_link,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "button is-normal is-default",
    attrs: {
      "id": "go-to-explorer"
    }
  }, [_vm._v(" View on explorer  "), _c('i', {
    staticClass: "fa fa-external-link fs-12 mt-5 ml-5"
  })])]) : _vm._e(), _c('a', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd",
    on: {
      "click": _vm.openConnectionId
    }
  }, [_c('button', {
    staticClass: "button is-normal is-default",
    attrs: {
      "id": "go-to-explorer"
    }
  }, [_vm._v(" View your Key"), _c('i', {
    staticClass: "fa fa-key fs-13 mt-1 ml-5"
  })])]), _c('button', {
    staticClass: "button is-normal is-light is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd hint--top",
    attrs: {
      "aria-label": "To scan it in our monitoring app"
    },
    on: {
      "click": _vm.generateQR
    }
  }, [_vm._v("Show QR"), _c('i', {
    staticClass: "fa fa-qrcode fs-14 ml-5 mt-3"
  })]), _c('a', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd",
    on: {
      "click": _vm.findAddressPre
    }
  }, [_c('button', {
    staticClass: "button is-normal is-default",
    attrs: {
      "id": "go-to-explorer"
    }
  }, [_vm._v(" Reload Stats"), _c('i', {
    staticClass: "fa fa-refresh fs-12 mt-2 ml-5",
    class: {
      'fa-spin': _vm.isFindingAddress
    }
  })])])]) : _vm._e(), (_vm.isOpenPayingOutNow) ? _c('div', {
    key: "confirm-pay",
    staticClass: "confirm-pay-block"
  }, [_c('div', [_c('span', [_vm._v("You will receive")]), _c('span', [_vm._v(" ")]), _c('b', {
    staticClass: "light-bold",
    attrs: {
      "id": "payable_balance"
    }
  }, [_vm._v(_vm._s(_vm.balancePayable))]), _c('b', {
    staticClass: "light-bold"
  }, [_vm._v(" " + _vm._s(_vm.coin))]), (_vm.chains.length > 1) ? [_c('span', {
    staticClass: "top-network-selected"
  }, [_vm._v(" through the  ")]), _c('b', {
    staticClass: "top-network-selected light-bold multi-chain-current-long"
  }, [_vm._v(" " + _vm._s(_vm.selectedChain.name) + " (" + _vm._s(_vm.selectedChain.token_standard) + ")")]), _c('span', {
    staticClass: "top-network-selected"
  }, [_vm._v(" network.")])] : _vm._e()], 2), _c('div', {
    staticClass: "end"
  }, [_c('span', [_vm._v("A manual payout  ")]), _c('b', {
    staticClass: "light-bold"
  }, [_vm._v("can be asked once a day (starting at 00:00 UTC)")])]), _c('button', {
    staticClass: "button is-normal is-success",
    class: {
      'is-loading': _vm.isPayingOutNow
    },
    attrs: {
      "id": "do_pay",
      "disabled": _vm.isPayingOutNow
    },
    on: {
      "click": _vm.doPayout
    }
  }, [_vm._v("Yes, continue")]), _c('button', {
    staticClass: "button is-normal is-default",
    attrs: {
      "id": "cancel_pay"
    },
    on: {
      "click": function($event) {
        _vm.isOpenPayingOutNow = false
      }
    }
  }, [_vm._v("No")])]) : _vm._e(), (_vm.isOpenSwitchingNetwork) ? _c('div', {
    key: "confirm-switch",
    staticClass: "confirm-switch-network"
  }, [_c('div', {
    staticClass: "w400"
  }, [_c('span', [_vm._v("If you are switching between compatible chains, make sure that your wallet has support for the chain you are selecting, and that it reuses the same address (if the address is different, you will lose your funds).")])]), _c('div', {
    staticClass: "w400 mt-10"
  }, [_c('span', [_vm._v("If you are mining to an exchange, double check that your exchange reuses the same address for the network that you are selecting.")])]), _c('div', {
    staticClass: "w400 s12 mt-10"
  }, [_c('u', [_vm._v("In any case, please make sure that you can receive your coins to the same exact address on the new network (chain) you are switching to, otherwise you will lose your funds.")])]), _c('div', {
    staticClass: "w400 s12 mt-10"
  }, [_c('span', [_vm._v("Also note that ")]), _c('b', [_vm._v("your balance will remain unchanged (it will not reset to zero) whenever you switch your payout network.")])]), _c('div', {
    staticClass: "w400 mt-10"
  }, [_c('span', [_vm._v("Kindly read carefully  ")]), _c('a', {
    staticClass: "s12",
    attrs: {
      "href": "https://unmineable.com/support/article/what-is-multi-chain-support-and-how-to-use-it/"
    }
  }, [_c('b', [_vm._v("our support center article  ")]), _c('i', {
    staticClass: "fa fa-external-link"
  })]), _c('span', [_vm._v(", to prevent losing any funds when processing your next payout.")])]), _c('div', {
    staticClass: "w400 mt-10"
  }, [_c('span', [_vm._v("Switching networks is instant and your next payout will be sent through the new network.")])]), _c('div', {
    staticClass: "network-selector mt-10"
  }, _vm._l((_vm.chains), function(item) {
    return _c('div', {
      staticClass: "network-item"
    }, [_c('div', {
      staticClass: "network-name w400"
    }, [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.network) + ")")]), _c('div', {
      staticClass: "network-token"
    }, [_vm._v(_vm._s(item.token_standard))]), _c('div', {
      staticClass: "network-feature"
    }, [_c('span', [_vm._v("Payment threshold: ")]), _c('span', {
      staticClass: "w400"
    }, [_vm._v(_vm._s(item.payment_threshold))])]), _c('div', {
      staticClass: "network-feature"
    }, [_c('span', [_vm._v("Payment status: ")]), _c('span', {
      staticClass: "w400"
    }, [(item.enabled) ? [_vm._v("Enabled")] : [_vm._v("Maintenance")]], 2)]), (item.contract) ? _c('div', {
      staticClass: "network-feature"
    }, [_c('span', [_vm._v("Contract: ")]), _c('a', {
      staticClass: "w400",
      attrs: {
        "href": item.explorer_address + item.contract,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.contract.substring(0, 5)) + "..." + _vm._s(item.contract.substring(item.contract.length - 5)))])]) : _vm._e(), (_vm.isConfirmingSwitchNetwork && item.network === _vm.selectedChainToSwitch.network) ? _c('div', {
      staticClass: "confirm-block-network"
    }, [_vm._v("Before continuing, double check that you have access to the exact same address on the " + _vm._s(item.network) + " network, otherwise you may lose your mined funds on the next payout. If you are using an exchange double check that it reuses the same address for the " + _vm._s(item.network) + " network."), _c('div', {
      staticClass: "button-selector has-text-right"
    }, [_c('a', {
      staticClass: "button is-default is-small cancel-confirm-network",
      on: {
        "click": _vm.cancelConfirmingSwitchNetwork
      }
    }, [_vm._v("Cancel")]), _c('a', {
      staticClass: "button is-success is-small do-switch-network",
      class: {
        'is-loading': _vm.isSwitchingNetwork
      },
      attrs: {
        "data-network": item.network,
        "disabled": _vm.isSwitchingNetwork
      },
      on: {
        "click": function($event) {
          return _vm.doSwitchNetwork(item)
        }
      }
    }, [_vm._v("Continue")])])]) : _vm._e(), (!(_vm.isConfirmingSwitchNetwork && item.network === _vm.selectedChainToSwitch.network)) ? _c('div', {
      staticClass: "button-selector button-selector-pre has-text-right"
    }, [(item.compatible) ? _c('a', {
      staticClass: "button is-default is-small hint--top text-black-on-dark",
      attrs: {
        "aria-label": 'Check your address on a ' + item.network + ' explorer.',
        "href": item.explorer_address_link,
        "target": "_blank"
      }
    }, [_vm._v("Explorer "), _c('i', {
      staticClass: "fa fa-external-link"
    })]) : _vm._e(), (item.network === _vm.selectedChain.network && item.compatible) ? _c('a', {
      staticClass: "button is-success is-small hint--top",
      attrs: {
        "aria-label": "Current network",
        "disabled": "disabled"
      }
    }, [_vm._v("Use")]) : _vm._e(), (item.network !== _vm.selectedChain.network && item.compatible) ? _c('a', {
      staticClass: "button show-confirm-network is-success is-small",
      on: {
        "click": function($event) {
          return _vm.confirmingSwitchNetwork(item)
        }
      }
    }, [_vm._v("Use")]) : _vm._e(), (!item.compatible) ? _c('a', {
      staticClass: "button is-success is-small hint--top",
      attrs: {
        "disabled": "disabled",
        "aria-label": "Non-compatible network"
      }
    }, [_vm._v("Use")]) : _vm._e()]) : _vm._e()])
  }), 0), _c('button', {
    staticClass: "button is-normal is-default",
    attrs: {
      "id": "cancel_switch"
    },
    on: {
      "click": function($event) {
        _vm.isOpenSwitchingNetwork = false
      }
    }
  }, [_vm._v("Go back")])]) : _vm._e(), (!_vm.isEnabled && _vm.isEnabledOnlyAutomatic) ? _c('div', {
    key: "only-automatic-message",
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("Payouts for ")]), _c('strong', [_vm._v(_vm._s(_vm.coin) + " ")]), _c('span', [_vm._v("are processed automatically once a day. Be sure to set your auto-payout setting to On!")])]) : _vm._e(), _c('div', {
    key: "autopay",
    staticClass: "autopay-switch-block"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('span', {
    staticClass: "switch-"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoPay),
      expression: "autoPay"
    }],
    attrs: {
      "id": "setting-auto_pay",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoPay) ? _vm._i(_vm.autoPay, null) > -1 : (_vm.autoPay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.autoPay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoPay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoPay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoPay = $$c
        }
      }, _vm.doChangeAutoPay]
    }
  }), _c('div', {
    staticClass: "slider- round-"
  })]), _c('span', [_c('span', [_vm._v(" Auto pay  ")]), _c('b', {
    staticClass: "light-bold"
  }, [_vm._v("once a day (at 01:00 UTC)  ")]), _c('span', [_vm._v("whenever my balance is over  ")]), _c('b', {
    staticClass: "light-bold threshold_amount"
  }, [_vm._v(_vm._s(_vm._f("thousandComma")(_vm.paymentThreshold)) + " ")]), _c('span'), _c('b', {
    staticClass: "light-bold"
  }, [_vm._v(_vm._s(_vm.coin))]), _c('div', {
    staticClass: "hint--top-left hint--large has-text-left cursor-pointer autopay-message",
    attrs: {
      "aria-label": "You must receive at least one reward on the past UTC day for your auto payment to be processed."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle ml-5"
  })])])])])])], 1)])]), (_vm.uuid) ? _c('stat-notification', {
    attrs: {
      "chain": _vm.selectedChain,
      "address": _vm.address,
      "chains": _vm.chains,
      "isMissingMemo": _vm.isMissingMemo,
      "hasPaymentError": _vm.hasPaymentError,
      "isRestricted": _vm.isRestricted,
      "isEnabled": _vm.isEnabled,
      "isEnabledOnlyAutomatic": _vm.isEnabledOnlyAutomatic,
      "isDelisted": _vm.isDelisted,
      "isFresh": _vm.isFresh,
      "isNotActivated": _vm.isNotActivated,
      "hasNoWorkers": _vm.hasNoWorkers,
      "addressFromDB": _vm.addressFromDB,
      "maintenanceMessage": _vm.maintenanceMessage
    }
  }) : _vm._e(), _c('tab-option', {
    attrs: {
      "selectedTab": _vm.selectedTab,
      "hasCustomCode": _vm.hasCustomCode
    },
    on: {
      "selected": _vm.changeTab
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab.code === 'hub'),
      expression: "selectedTab.code === 'hub'"
    }],
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingHub
    }
  }, [_vm._m(2), _c('Slider', {
    attrs: {
      "slides": _vm.tileBlocks.length
    }
  }, _vm._l((_vm.tileBlocks), function(b) {
    return _c('div', {
      staticClass: "slide-box has-text-left slide"
    }, [_c('div', {
      staticClass: "tile is-ancestor"
    }, _vm._l((b), function(o) {
      return _c('a', {
        staticClass: "tile is-parent",
        attrs: {
          "href": o.link,
          "target": "_blank"
        }
      }, [_c('article', {
        staticClass: "tile is-child box"
      }, [_c('p', {
        staticClass: "title is-spaced"
      }, [_vm._v(_vm._s(o.title))]), _c('p', {
        staticClass: "subtitle"
      }, [_c('span', [_vm._v(_vm._s(o.subtitle))]), (o.link) ? [_c('span', [_vm._v(" ")]), _c('i', {
        staticClass: "fa fa-external-link"
      })] : _vm._e()], 2)])])
    }), 0)])
  }), 0), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('news', {
    attrs: {
      "inStats": true,
      "countOverride": 4
    }
  })], 1), _c('div', {
    staticClass: "column is-half"
  }, [_c('PlatformStats'), _vm._m(3)], 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab.code === 'workers'),
      expression: "selectedTab.code === 'workers'"
    }],
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingWorkersData
    }
  }, [_c('div', {
    staticClass: "result-address"
  }, [(_vm.hasNoWorkers) ? _c('div', {
    staticClass: "result-no-workers pos-r has-text-left padding-workers text-white-on-dark"
  }, [_c('span', [_vm._v("You have no workers online.")]), _c('br'), _c('br'), _c('span', {
    staticClass: "w400"
  }, [_vm._v("TIP:  ")]), _c('span', [_vm._v(" You can mine different algorithms at the same time, with different worker names.")])]) : _vm._e()]), _c('tab-workers', {
    ref: "workerstab",
    attrs: {
      "uuid": _vm.uuid
    },
    on: {
      "hasNoWorkers": function($event) {
        _vm.hasNoWorkers = true
      },
      "hasWorkers": function($event) {
        _vm.hasNoWorkers = false
      },
      "startLoading": function($event) {
        _vm.isLoadingWorkersData = true
      },
      "stopLoading": function($event) {
        _vm.isLoadingWorkersData = false
      }
    }
  })], 1), (_vm.selectedTab.code === 'live' && _vm.uuid) ? _c('div', {
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingLiveData
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "result-address"
  }, [_c('tab-live', {
    ref: "livetab",
    attrs: {
      "uuid": _vm.uuid,
      "summary": _vm.summary
    },
    on: {
      "startLoading": function($event) {
        _vm.isLoadingLiveData = true
      },
      "stopLoading": function($event) {
        _vm.isLoadingLiveData = false
      },
      "goToTab": _vm.changeTab
    }
  })], 1)])])]) : _vm._e(), (_vm.selectedTab.code === 'payments' && _vm.uuid) ? _c('div', {
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingPaymentsData
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "result-address"
  }, [_c('tab-payments', {
    ref: "paymentstab",
    attrs: {
      "isMultiChain": _vm.chains.length > 1,
      "uuid": _vm.uuid
    },
    on: {
      "startLoading": function($event) {
        _vm.isLoadingPaymentsData = true
      },
      "stopLoading": function($event) {
        _vm.isLoadingPaymentsData = false
      }
    }
  })], 1)])])]) : _vm._e(), (_vm.selectedTab.code === 'referrals' && _vm.uuid) ? _c('div', {
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingReferralData
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "result-address"
  }, [_c('tab-referral', {
    ref: "referralstab",
    attrs: {
      "uuid": _vm.uuid
    },
    on: {
      "startLoading": function($event) {
        _vm.isLoadingReferralData = true
      },
      "stopLoading": function($event) {
        _vm.isLoadingReferralData = false
      }
    }
  })], 1)])])]) : _vm._e(), (_vm.selectedTab.code === 'stats' && _vm.uuid) ? _c('div', {
    staticClass: "tab-content",
    class: {
      'is-loading': _vm.isLoadingStatsData
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "result-address"
  }, [_c('tab-stats', {
    ref: "statstab",
    attrs: {
      "paymentThreshold": _vm.paymentThreshold,
      "miningFee": _vm.miningFee,
      "uuid": _vm.uuid
    },
    on: {
      "startLoading": function($event) {
        _vm.isLoadingStatsData = true
      },
      "stopLoading": function($event) {
        _vm.isLoadingStatsData = false
      }
    }
  })], 1)])])]) : _vm._e()], 2), (_vm.missingMemoView) ? _c('div', {
    staticClass: "column col-result is-full"
  }, [_c('button', {
    staticClass: "button button-back-search",
    on: {
      "click": function($event) {
        return _vm.closeCurrentAddress()
      }
    }
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  }), _c('span', [_vm._v("Back")])]), _c('div', {
    staticClass: "result-address"
  }, [_c('br'), _vm._m(4), _vm._m(5), _c('div', {
    staticClass: "fs-20 mt-10"
  }, [_c('b', [_vm._v(_vm._s(_vm.address))])]), _vm._m(6), _vm._m(7), _c('div', {
    staticClass: "fs-17 mt-10 wb-ba"
  }, [_c('b', {
    staticClass: "opacity-05"
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(":")]), _c('b', {
    staticClass: "opacity-05"
  }, [_vm._v(_vm._s(_vm.address))]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(":")]), _c('b', [_vm._v("YourPaymentID")]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(".")]), _c('b', {
    staticClass: "opacity-05"
  }, [_vm._v("YourWorkerName")])]), _vm._m(8), _vm._m(9)])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-label"
  }, [_c('span', [_vm._v("Enter your address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-label"
  }, [_c('span', [_vm._v("Filter your ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("search history ")]), _c('span', [_vm._v(" by coin or token ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-16 text-white-on-dark pb-5 pt-20"
  }, [_c('b', [_vm._v("Spotlight")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100"
  }, [_c('hr'), _c('p', [_vm._v("If you have any issue, question or suggestion contact us here:")]), _c('br'), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Email (Official Support Channel)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "mailto:support@unmineable.com"
    }
  }, [_c('b', [_vm._v("support@unmineable.com")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("X (formerly Twitter)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@un_mineable")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Instagram")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://instagram.com/unminable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@unminable")])])]), _c('div', {
    staticClass: "mt-15"
  }, [_c('span', [_vm._v("Beware of impersonators, we have no official Telegram or Discord channels.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-18 mt-10"
  }, [_c('span', [_vm._v("⚠️")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-14 mt-10"
  }, [_c('span', [_vm._v("Please note that if you are currently trying to mine to this address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-14 mt-10"
  }, [_c('b', [_vm._v("You'll have all of your connections rejected as it is an exchange or custodial wallet address that requires payment tags for payouts. Any mining rewards associated with this address (without a payment tag) are unrecoverable and non-transferable.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-14 mt-10"
  }, [_c('b', [_vm._v("To correctly start mining, ")]), _c('span', [_vm._v(" include your Payment ID, Memo, or Tag immediately after the address in the user parameter of your miner, separated by a colon (:), like this:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-12 mt-10"
  }, [_c('span', [_vm._v("Learn more about ")]), _c('a', {
    attrs: {
      "href": "/support/article/why-is-it-necessary-to-write-the-memo-or-payment-tag",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("exchange addresses ")]), _c('i', {
    staticClass: "fa fa-external-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-14 mt-10"
  }, [_c('span', [_vm._v("Happy mining!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13e23816","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Stats.vue
// module id = 360
// module chunks = 1